var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckedOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 448,
    height: 448,
    viewBox: "0 0 448 448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32Zm0,400H48V80H400ZM364.14,190.28,191.55,361.48a12,12,0,0,1-17-.07L83.8,269.9a12,12,0,0,1,.06-17l22.72-22.54a12,12,0,0,1,17,.07l59.8,60.28L324.7,150.52a12,12,0,0,1,17,.07l22.53,22.72a12,12,0,0,1-.06,17Z",
    transform: "translate(0 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckedOk);
export default __webpack_public_path__ + "static/media/iconCheckedOk.7faa78a7532c45f8f55bd069e6dc7d27.svg";
export { ForwardRef as ReactComponent };